// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mb-button-block{margin-top:1rem;padding:1.5rem;width:100%}@media (min-width:768px){.mb-button-block{align-items:center;display:flex;justify-content:center;padding-bottom:2rem;padding-top:2rem}}.mb-button-block .mb-button-block__button{border-radius:.75rem;width:100%}@media (min-width:768px){.mb-button-block .mb-button-block__button{width:-moz-fit-content;width:fit-content}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
